import Header from "./header";
import Main from "./main";
import './Styles/App.css'



function App() {
  return (
    <div className="App">
      <Header/>
      <Main/> 
    </div>
  );
}

export default App;
